// import { useState, useEffect } from 'react';
// import axios from 'axios';
// import { apiurl } from '../config/config';

// const EmailInputField = ({ label, value, onChange }) => {
//   const [input, setInput] = useState('');
//   const [suggestions, setSuggestions] = useState([]);

//   const handleAdd = (email = input) => {
//     if (email && !value.includes(email)) {
//       onChange([...value, email]);
//       setInput('');
//       setSuggestions([]);
//     }
//   };

//   useEffect(() => {
//     const delayDebounce = setTimeout(() => {
//       if (input.length > 1) {
//         axios
//           .get(`${apiurl}/api/user/search`, { params: { search: input } })
//           .then(res => {
//             setSuggestions(res.data.users || []);
//           })
//           .catch(err => {
//             console.error('Error fetching suggestions:', err.message);
//           });
//       } else {
//         setSuggestions([]);
//       }
//     }, 300); // debounce to limit requests

//     return () => clearTimeout(delayDebounce);
//   }, [input]);

//   return (
//     <div>
//       <label className="text-sm font-medium">{label}</label>
//       <div className="flex gap-2 mt-1">
//         <input
//           type="email"
//           value={input}
//           onChange={e => setInput(e.target.value)}
//           placeholder="Type and press add"
//           className="input flex-1"
//         />
//         <button
//           onClick={() => handleAdd()}
//           className="bg-indigo-500 text-white px-3 py-1 rounded"
//         >
//           Add
//         </button>
//       </div>
//       <div className="flex flex-wrap mt-2 gap-2">
//         {value.map((email, idx) => (
//           <span
//             key={idx}
//             className="bg-gray-200 px-2 py-1 rounded flex items-center gap-1"
//           >
//             {email}
//             <button onClick={() => onChange(value.filter((e, i) => i !== idx))}>❌</button>
//           </span>
//         ))}
//       </div>
//       {suggestions.length > 0 && (
//         <ul className="bg-white border mt-1 shadow rounded max-h-40 overflow-y-auto">
//           {suggestions.map((user, idx) => (
//             <li
//               key={idx}
//               onClick={() => handleAdd(user.email)}
//               className="px-2 py-1 hover:bg-gray-100 cursor-pointer"
//             >
//               {user.email}
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// };

// export default EmailInputField;


import { useState, useEffect } from 'react';
import axios from 'axios';
import { apiurl } from '../config/config';

const EmailInputField = ({ label, value, onChange }) => {
  const [input, setInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  const handleAdd = (email = input) => {
    if (email && !value.includes(email)) {
      onChange([...value, email]);
      setInput('');
      setSuggestions([]);
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (input.length > 1) {
        axios
          .get(`${apiurl}/api/user/search`, { params: { search: input } })
          .then(res => {
            setSuggestions(res.data.users || []);
          })
          .catch(err => {
            console.error('Error fetching suggestions:', err.message);
          });
      } else {
        setSuggestions([]);
      }
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [input]);

  return (
    <div className="mb-4 w-full">
      <label className="text-sm font-medium text-gray-700">{label}</label>
      <div className="flex gap-2 mt-1">
        <input
          type="email"
          value={input}
          onChange={e => setInput(e.target.value)}
          placeholder="Type and press add"
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
        <button
          onClick={() => handleAdd()}
          className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700"
        >
          Add
        </button>
      </div>

      {value.length > 0 && (
        <div className="flex flex-wrap mt-2 gap-2">
          {value.map((email, idx) => (
            <span
              key={idx}
              className="bg-gray-100 border border-gray-300 text-sm px-3 py-1 rounded-md flex items-center gap-2"
            >
              {email}
              <button
                onClick={() => onChange(value.filter((_, i) => i !== idx))}
                className="text-red-500 hover:text-red-700"
              >
                ✕
              </button>
            </span>
          ))}
        </div>
      )}

      {suggestions.length > 0 && (
        <ul className="bg-white border border-gray-300 mt-2 shadow-sm rounded-md max-h-40 overflow-y-auto">
          {suggestions.map((user, idx) => (
            <li
              key={idx}
              onClick={() => handleAdd(user.email)}
              className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm"
            >
              {user.email}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default EmailInputField;
